import { ajax } from 'cadenza/api-client//api';
import { HEADER_EXPORT_TYPE, PARAMETER_MIMETYPE } from 'cadenza/api-client/api-constants';
import type { WorkOrderId } from 'cadenza/api-client/workorder-api';
import { extendUrlParameters } from 'cadenza/utils/url-param-utils';

export function canExport (layerId: string, mapScale: number, mimeType: string, signal: AbortSignal) {
  const searchParams = new URLSearchParams({ mapScale: String(mapScale) });
  searchParams.append(PARAMETER_MIMETYPE, mimeType);
  return ajax(`/layers/${layerId}?${searchParams.toString()}`, {
    method: 'OPTIONS',
    signal
  });
}

export function startExport (layerId: string, mapScale: number, srsCode: string, includeCoordinates: boolean, mimeType: string): Promise<WorkOrderId> {
  const params = {
    mapScale,
    srsCode,
    includeCoordinates
  };

  return ajax(
    extendUrlParameters(`/layers/${layerId}`, params),
    { headers: { [HEADER_EXPORT_TYPE]: mimeType } }
  );
}
